import type { PyneSettings } from "./global";

export function loadCustomPyneSettings(pyneSettings: PyneSettings) {
  const { app_id } = pyneSettings;
  const newSettings: PyneSettings = { ...pyneSettings };

  // Theydo
  if (app_id === "47727a66-5898-4798-bac5-430dad2d1d61") {
    newSettings.segment = true;
    newSettings.theme = "theydo";
    newSettings.skipBlobMediaPreload = true;
  }

  // Staffomatic
  if (app_id === "33f9e2cb-25f0-4eab-8c07-8dabf53250f0") {
    newSettings.theme = "staffomatic";
  }

  // Superchat
  if (app_id === "7f9070a0-ba13-42bf-bb1a-c0d01e513e8f") {
    newSettings.theme = "superchat";
  }

  // Moovs
  if (app_id === "e91c65ed-a16f-47a2-b056-4ed942f69b3e") {
    newSettings.segment = true;
  }

  // Hipeople
  if (app_id === "0ff0676f-bfb6-4b0d-a3d0-f52c579e734a") {
    newSettings.theme = "hipeople";
  }

  // Compa
  if (app_id === "c1920f5e-8e7d-4411-a7ed-d4d9de35548f") {
    newSettings.segment = true;
  }

  // Fynk
  if (app_id === "b318397e-d39f-4798-ad69-ef1a72ee2885") {
    newSettings.theme = "fynk";
  }

  // Herofr
  if (app_id === "5c9263ed-2d92-4413-af86-284e27317679") {
    newSettings.theme = "herofr";
    newSettings.mediaPlaybackRate = 1.15;
  }

  // Herofr2
  if (app_id === "196f22f4-cfa4-4e65-850e-525c1dfff1fc") {
    newSettings.theme = "herofr";
    newSettings.mediaPlaybackRate = 1.15;
  }

  //mypaperwork
  if (app_id === "c476fc1d-39e8-48cb-bb33-ef75ef970424") {
    newSettings.mediaPlaybackRate = 1.1;
    newSettings.theme = "mypaperwork";
  }

  // Treinta
  if (app_id === "e34486e3-0e15-43eb-8433-a2ff75baa303") {
    newSettings.theme = "treinta";
  }

  if (app_id === "775be281-dfba-4fab-9336-12dca5a8ef4b") {
    newSettings.theme = "shortcut";
    newSettings.segment = true;
    newSettings.mediaPlaybackRate = 1.05;
    newSettings.highlightPlayButton = true;
    newSettings.avatarBackgroundPreviewGifUrl =
      "https://base.pyne.ai/storage/v1/object/public/tour-assets/avatar-background-previews/shortcut.gif";
  }

  if (app_id === "9497aecd-86db-42db-a9ac-8a43eecb20f7") {
    newSettings.showWatermark = true;
  }

  if (app_id === "54da0c55-4137-45e1-83d5-9174e9f77f25") {
    newSettings.showFeedbackButton = false;
  }

  return newSettings;
}
